'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmallCard = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(SmallCard, _Component);

  function SmallCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SmallCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SmallCard.__proto__ || (0, _getPrototypeOf2.default)(SmallCard)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      var styles = require('./SmallCard.scss');
      event.target.classList.add(styles.noImg);
      event.target.onerror = null;
      event.target.src = '/no-image-voucher.jpg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SmallCard, [{
    key: 'render',
    value: function render() {
      var styles = require('./SmallCard.scss');
      var _props = this.props,
          className = _props.className,
          _props$card = _props.card,
          handle = _props$card.handle,
          image = _props$card.image,
          name = _props$card.name,
          address = _props$card.address,
          addressDisplay = _props$card.addressDisplay,
          mainCat = _props.mainCat,
          onPress = _props.onPress;

      return _react2.default.createElement(
        _reactRouter.Link,
        {
          to: '/' + handle,
          className: styles.smallCard + ' ' + className,
          onClick: onPress
        },
        _react2.default.createElement(
          'div',
          { className: styles.box },
          _react2.default.createElement(
            'div',
            { className: styles.contentBox },
            _react2.default.createElement(
              'div',
              { className: styles.left },
              _react2.default.createElement('img', {
                src: image ? image : '/no-image-voucher.jpg',
                onError: this.onErrorImage,
                alt: ''
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.right },
              _react2.default.createElement(
                'div',
                { className: styles.category },
                mainCat
              ),
              _react2.default.createElement(
                'div',
                { className: styles.name },
                name
              ),
              _react2.default.createElement(
                'div',
                { className: styles.address },
                _react2.default.createElement(
                  'div',
                  { className: styles.icon },
                  _react2.default.createElement('img', { src: '/icon/ic_address/ic_address.png', alt: '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  addressDisplay ? addressDisplay : address
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SmallCard;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  card: _react.PropTypes.object,
  // handleClick: PropTypes.func,
  mainCat: _react.PropTypes.string,
  onPress: _react.PropTypes.func
}, _temp2);
exports.default = SmallCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/SmallCard.js
// module id = 1584
// module chunks = 0